import React from "react";

function Calculator() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" d="M5 9h14"/><path strokeLinejoin="round" d="M5 3h14v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3Z"/><path strokeLinecap="round" d="M9 13h1m4 0h1m-6 4h1m4 0h1"/></g></svg>
  );
}

export default Calculator;

 